import BaseServices from './../../../helpers/BaseServices';
import { MODULE_ENDPOINT } from "./constants";

export default class Services extends BaseServices {
  constructor() {
    super(MODULE_ENDPOINT);
  };

  contato = (dados) => {
    
    return fetch(`${MODULE_ENDPOINT}/email/contato`, BaseServices._getRequestInfo('POST', `${JSON.stringify(dados)}`))    
      .then(response => {
        if (!response.ok) {
          throw response.json();
        }

        return response.json();
      });
  }
}